import { get, post, put, patch } from "../Config"

export function SearchPdpaNewPage({ params = {}, lang }) {
  return get({ url: `/v1/admin/pdpa-new-page`, params, lang })
}
export function GetPdpaNewPageById({ id, params = {}, lang, }) {
  return get({ url: `/v1/admin/pdpa-new-page/${id}`, params , lang })
}
export function CreatePdpaNewPage({ params = {}, data = {}, lang }) {
  return post({ url: `/v1/admin/pdpa-new-page`, params, data, lang })
}
export function UpdatePdpaNewPage({ params = {}, data = {} , id, lang }) {
  return put({ url: `/v1/admin/pdpa-new-page/${id}`, params, data, lang })
}
export function PatchPdpaNewPage({ params = {}, data = {} , id, lang }) {
  return patch({ url: `/v1/admin/pdpa-new-page/${id}`, params, data, lang })
}
export function DeletePdpaNewPage({ params = {}, data = {}, lang }) {
  return post({ url: `/v1/admin/pdpa-new-page/mutiDelete`, params, data, lang })
}
